import dom from '../../lib/dom.js';
import preconditions from '../../lib/preconditions.js';

const checkPreconditions = preconditions('toggleEmptyWarning', {
    root: 'element',
    result: 'object',
    eventHub: 'eventHub',
});

export default function toggleEmptyWarning(params) {
    checkPreconditions(params);
    function showOrHideWarning(result) {
        if (result.numFound) {
            dom.addClass('u-display-none', dom.byId('emptyWarningContainer'));
        } else {
            dom.removeClass('u-display-none', dom.byId('emptyWarningContainer'));
        }
    }

    showOrHideWarning(params.result);
    params.eventHub.subscribe('changed-results', (result) => {
        showOrHideWarning(result);
    });
}
